<script module lang="ts">
  import type { Snippet } from 'svelte';
  import { type AllowedState } from './states.types';

  export interface Props {
    size?: number;
    state?: AllowedState;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { allowedStates } from './states.types';
  import { LayerService } from '../../services/LayerService.svelte';

  // -
  const { state, size, children, ...toNext }: Props = $props();

  // -
  const UseState = $derived(state && allowedStates.includes(state) ? state : undefined);
  const UseColor = $derived(UseState ? 'color-' + UseState : 'layout-front');

  // -
  const Layer = new LayerService();
  const MyLayer = Layer.upContentLay();

  // -
  const UseSize = $derived(Math.max(1, Math.min(Math.round(size || 1), 6)));
  const UseTag = $derived('h' + String(UseSize));

  // -
  const SizeMapper: Record<number, number> = {
    1: 2,
    2: 1.5,
    3: 1.25,
  };
  const UseSizeFactor = $derived(SizeMapper[UseSize] ?? 1);
</script>

<header {...toNext} class="headLineHeader contentLayer contentLayer{MyLayer}">
  <svelte:element this={UseTag} class="headLine" style:--color-font={`var(--${UseColor}-accent)`} style:--font-size-factor={UseSizeFactor}>
    {@render children?.()}
  </svelte:element>
</header>

<style lang="scss">
  .headLine {
    font-weight: 900;
    font-size: calc(var(--font-size) * var(--font-size-factor));
    color: var(--color-font);
  }
</style>
